<!-- 2 columns form -->
<form name="clientform" [formGroup]="clientForm" novalidate>
  <div class="panel panel-flat">
    <div class="panel-heading">
      <h5 class="panel-title">Clients</h5>
      <div class="heading-elements">
        <ul class="icons-list">
          <li>
            <a data-action="reload" (click)="reset()"></a>
          </li>
        </ul>
      </div>
      <hr class="divider">
    </div>

    <div class="panel-body">

      <div class="row">
        <div class="col-md-7">


          <fieldset>
            <legend class="text-semibold">
              <i class="icon-list position-left"></i> Clients
            </legend>
            <table class="table datatable-column-search-inputs">
              <thead>
                <tr>
                  <th>Trade Name</th>
                  <th>Business Category</th>
                  <th>Registration Date</th>
                  <th>TIN Number</th>
                  <th>Type</th>
                  <th>Status</th>
                  <th>Remark</th>
                  <th class="text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="let client of clients | paginate: { id: 'clients',itemsPerPage: itemsPerPage,currentPage: currentPage,totalItems: totalItems }">
                  <!--  <td>{{client?.trade_name}}</td> -->
                  <td>
                    <div class="media">
                      <span class="media-left">
                        <img *ngIf="!client.logo" src="assets/img/userm.png" width="40" height="40"
                          class="img-circle img-md" alt="">
                        <a href="javascript:void(0)" data-toggle="modal" data-target="#profileImModal">
                          <img *ngIf="client.logo" [src]="baseUrl+'assets/'+client.logo+'/render'" width="40"
                            height="40" class="img-circle img-md" alt="">
                        </a>
                      </span>
                      <div class="media-right">{{client?.trade_name}}
                      </div>
                    </div>
                  </td>
                  <td>{{client?.business_category}}</td>
                  <td>{{client?.registration_date|date:short}}</td>
                  <td>{{client?.tin_number}}</td>
                  <td>{{client?.type}}</td>
                  <td>
                    <span class="label label-block label-default"
                      *ngIf="client.status === 'Pending' || client.status === 'pending'">{{client.status}}</span>
                    <span class="label label-block bg-primary"
                      *ngIf="client.status === 'Active' || client.status === 'active'">{{client.status}}</span>
                    <span class="label label-block bg-danger"
                      *ngIf="client.status === 'Inactive' || client.status === 'inactive'">{{client.status}}</span>
                  </td>
                  <td>{{client.remark}}</td>
                  <td class="text-center">
                    <ul class="icons-list">
                      <li class="dropdown">
                        <a href="" class="dropdown-toggle" data-toggle="dropdown">
                          <i class="icon-menu9"></i>
                        </a>
                        <ul class="dropdown-menu dropdown-menu-right">
                          <li>
                            <!--  <a href="" [routerLink]="['/clientadd']" [queryParams]="{'id':client.id}"> -->
                            <a href="javascript:void(0);" (click)="editClient(client)">
                              <i class="icon-file-pdf"></i>Update</a>
                          </li>
                          <li>
                            <a href="">
                              <i class="icon-file-excel"></i>Delete</a>
                          </li>
                          <li class="dropdown-submenu dropdown-submenu-left">
                            <a href="javascript:void(0);">Change Status</a>
                            <ul class="dropdown-menu">
                              <li>
                                <a (click)="changeStatus(client,'pending')">
                                  <i class="icon-shuffle"></i> Pending</a>
                              </li>
                              <li>
                                <a (click)="changeStatus(client,'active')">
                                  <i class="icon-shuffle"></i> Active</a>
                              </li>
                              <li>
                                <a (click)="changeStatus(client,'inactive')">
                                  <i class="icon-shuffle"></i> Inactive</a>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </td>
                </tr>
                <tr *ngIf="clients?.length <=0">
                  <td colspan="6" class="text-center"> <i class="icon-info22">&nbsp;</i>No Clients registered yet!</td>
                </tr>
              </tbody>
            </table>


            <div class="row">
              <!-- <p class="text-left" style="color:#00695C;font-weight:600;padding:10px;">{{val}}</p> -->
              <div class="text-center">

                <pagination-controls id="clients" (pageChange)="pageChanged(currentPage = $event)">
                </pagination-controls>

                <br>
              </div>

            </div>

          </fieldset>
        </div>


        <div class="col-md-5">


          <fieldset>
            <legend class="text-semibold">
              <i class="icon-reading position-left"></i> Client Details
            </legend>

            <div class="row">
              <div class="col-lg-6">
                <div class="form-group required">
                  <span class="control-label"> Trade Name: </span>
                  <input type="text" name="trade_name" required formControlName="trade_name" class="form-control"
                    placeholder="Trade Name">
                  <div class="help-block" *ngIf="trade_name.invalid && (trade_name.dirty || trade_name.touched)">
                    <p class="text-danger">
                      <i class="icon-cancel-circle2 position-left text-red"></i> Trade name is required
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-lg-6">
                <div class="form-group required">
                  <span class="control-label"> Business Caategory: </span>
                  <input type="text" name="business_category" required formControlName="business_category"
                    class="form-control" placeholder="Business Category">
                  <div class="help-block"
                    *ngIf="business_category.invalid && (business_category.dirty || business_category.touched)">
                    <p class="text-danger">
                      <i class="icon-cancel-circle2 position-left text-red"></i> Business Category is required
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="form-group required">
                  <span class="control-label">Registration Date: </span>
                  <input type="date" name="registration_date" formControlName="registration_date" class="form-control"
                    placeholder="Registration Date">
                  <!-- <div class="help-block"
                    *ngIf="transaction_date.invalid && (transaction_date.dirty || transaction_date.touched)">
                    <p class="text-danger">
                      <i class="icon-cancel-circle2 position-left"></i>Transaction date is required.
                    </p>
                  </div> -->
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group required">
                  <span class="control-label">TIN Number: </span>
                  <input type="text" name="tin_number" required formControlName="tin_number" class="form-control"
                    placeholder="TIN Number">
                  <div class="help-block" *ngIf="tin_number.invalid && (tin_number.dirty || tin_number.touched)">
                    <p class="text-danger">
                      <i class="icon-cancel-circle2 position-left"></i>MTIN Number is required
                    </p>
                  </div>
                </div>
              </div>



            </div>



            <div class="row">

              <div class="col-md-6">
                <div class="form-group required">
                  <span class="control-label">Type: </span>
                  <select name="type" required formControlName="type" class="form-control"
                    data-placeholder="Select business type">
                    <option selected disabled>Type:</option>
                    <option value="sole-properietor">Sole Properietor</option>
                    <option value="plc">PLC</option>
                    <option value="share company">Share Company</option>
                  </select>
                  <div class="help-block" *ngIf="type.invalid && (type.dirty || type.touched)">
                    <p class="text-danger">
                      <i class="icon-cancel-circle2 position-left"></i>Business Type is required.
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group required">
                  <span class="control-label">Status: </span>
                  <select name="status" required formControlName="status" class="form-control"
                    data-placeholder="Select offer status">
                    <option selected disabled>Status:</option>
                    <option value="pending">Pending</option>
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                  </select>
                  <div class="help-block" *ngIf="status.invalid && (status.dirty || status.touched)">
                    <p class="text-danger">
                      <i class="icon-cancel-circle2 position-left"></i>Offer status is required.
                    </p>
                  </div>
                </div>
              </div>
            </div>


            <div class="row">

              <div class="form-group">
                <label>&nbsp;</label>
                <label>Remark:</label>
                <textarea rows="5" cols="5" class="form-control" name="remark" formControlName="remark"
                  placeholder="Additional information . . ." required></textarea>
                <div class="help-block" *ngIf="remark.invalid && (remark.dirty || remark.touched)">
                  <p class="text-danger">
                    <i class="icon-cancel-circle2 position-left"></i>Please write small description about the client
                  </p>
                </div>
              </div>
            </div>


            <div class="row">
              <div class="col-md-12">
                <!-- <ngx-dropzone (change)="onSelect($event)">
                  <ngx-dropzone-label> - Drop Client Logo here - </ngx-dropzone-label>
                  <ngx-dropzone-preview *ngFor="let f of files" [removable]="true" (removed)="onRemove(f)">
                    <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
                  </ngx-dropzone-preview>
                </ngx-dropzone> -->
                <div class="custom-dropzone" ngx-dropzone [accept]="'image/*'" (change)="onFilesAdded($event)">
                  <ngx-dropzone-label>
                    <div>
                      <h6 style="color:gray;" translate>- Drop Client Logo here -</h6>
                    </div>
                  </ngx-dropzone-label>
                  <ngx-dropzone-image-preview ngProjectAs="ngx-dropzone-preview" *ngFor="let f of files" [file]="f"
                    [removable]="true" (removed)="onRemove(f)">
                  </ngx-dropzone-image-preview>
                </div>
              </div>

            </div><br>

          </fieldset>

          <div class="text-right">

            <!--  <button class="btn bg-slate-800" (click)="addNews(client.id)" type="submit" data-style="slide-right" [ladda]="isLoading" [disabled]="newsForm.invalid">
              <span *ngIf="!client.id">Save News</span>
              <span *ngIf="client.id">Update News</span>
              <i class="icon-floppy-disk position-right"></i>
            </button> -->
            <button class="btn bg-slate-800" (click)="addClient()" type="submit" data-style="slide-right"
              [disabled]="clientForm.invalid">
              <span *ngIf="operation=='add'">Save Client</span>
              <span *ngIf="operation!='add'">Update Client</span>
              <i class="icon-floppy-disk position-right"></i>
            </button>

          </div>


        </div>

      </div>





    </div>
  </div>
</form>
<!-- /2 columns form -->